import VueCookies from 'vue-cookies'

const AUTH_FAIL_COUNT_KEY = 'auth-fail-count'
const AUTH_FAIL_COUNT_THRESHOLD = 5
const AUTH_VIEWS = [
    '/sign_in',
    '/signed_out',
    '/auth_error'
]
const IS_AUTHENTICATED_KEY = 'is-authenticated'
const JWT_COOKIE_NAME = 'jwt'
const PRE_AUTH_PATH_KEY = 'pre-auth-path'

export function getIsAuthView (): boolean {
    return AUTH_VIEWS.includes(window.location.pathname)
}

export function getIsAuthenticated (): boolean {
    return !!(localStorage.getItem(IS_AUTHENTICATED_KEY))
}

export function getJWT(): string|null {
    return VueCookies.get(JWT_COOKIE_NAME)
}

export function setIsAuthenticated (value: boolean, jwt: string = ''): void {
    if (value) {
        localStorage.setItem(IS_AUTHENTICATED_KEY, 'true')
        if (jwt) {
            VueCookies.set(JWT_COOKIE_NAME, jwt, { expires: '1h' })
        } else {
            throw new Error('authorization-required')
        }
    } else {
        localStorage.removeItem(IS_AUTHENTICATED_KEY)
        VueCookies.remove(JWT_COOKIE_NAME)
    }
}

export function getPreAuthPath (): string | null {
    return localStorage.getItem(PRE_AUTH_PATH_KEY)
}

export function setPreAuthPath (path: string | null): void {
    if (path) {
        localStorage.setItem(PRE_AUTH_PATH_KEY, path)
    } else {
        localStorage.removeItem(PRE_AUTH_PATH_KEY)
    }
}

export function getAuthFailCount (): number {
    return parseInt(localStorage.getItem(AUTH_FAIL_COUNT_KEY)) || 0
}

export function incrementAuthFailCount (): void {
    const current = getAuthFailCount()
    localStorage.setItem(AUTH_FAIL_COUNT_KEY, (current + 1).toString())
}

export function isTooManyAuthFails (): boolean {
    return getAuthFailCount() >= AUTH_FAIL_COUNT_THRESHOLD
}

export function resetAuthFailCount (): void {
    localStorage.removeItem(AUTH_FAIL_COUNT_KEY)
}
